import { bffClient, bffBaseURL } from './request';

export interface ModelCard {
  name: string;
  support_thinking: boolean | 'optional';
  max_context_length: number;
  max_tokens?: number | null;
  support_reasoning_effort?: boolean;
  effort_values?: string[] | null;
  support_interleaved_thinking?: boolean;
  forbidden_params?: string[] | null;
}

export async function listModelCards(signal?: AbortSignal): Promise<ModelCard[]> {
  if (!bffBaseURL) throw new Error('未配置 BFF 地址，请设置 VITE_BFF_API_BASE_URL');
  const response = await bffClient.post<{ data?: { items?: ModelCard[] } }>(
    '/ListModelCards',
    {},
    { timeout: 5000, signal }
  );
  const data = response.data?.data;
  if (!data || (data.items !== undefined && !Array.isArray(data.items))) {
    throw new Error('模型能力目录响应无效');
  }
  const items = data.items ?? [];
  if (
    items.some(
      (card) =>
        !card ||
        typeof card.name !== 'string' ||
        ![true, false, 'optional'].includes(card.support_thinking)
    )
  ) {
    throw new Error('模型能力目录包含无效卡片');
  }
  return items;
}
